export const LocalStorageKeyTheme = 'mdb-home-theme';
export const ProductImagesDirectory = 'productImages';

export enum Environment {
    Production = 'Production',
    Development = 'Development',
    Staging = 'Staging',
}

export enum ContactMethod {
    Email = 'Email',
    Phone = 'Phone',
}

export enum SocialPlatform {
    YouTube = 'YouTube',
    Instagram = 'Instagram',
    Facebook = 'Facebook',
    Threads = 'Threads',
}

export enum DelishBowlCategory {
    Food = 'Food',
    HealthBeauty = 'Health & Beauty',
    Lifestyle = 'Lifestyle',
}
